import { IArrow } from '~/actions/extraHTML/wheelOfFortune/html/noRotationElements/arrows';

export const arrowContainerClass = 'arrowContainer';
export const arrowClass = 'arrow';

export const arrow = ({ radius, arrowNumber, degree }: IArrow) => {

  const arrowSize = radius / 60;
  const left = radius - arrowSize * 2;
  const top = - arrowSize * 4;
  const display = degree * arrowNumber === 90 ? 'none' : 'block';

  const arrowContainerStyles = `transform: rotate(${degree * arrowNumber}deg);`;

  const arrowStyles = `width: ${arrowSize}px;
    border: ${arrowSize * 2}px solid transparent;
    border-bottom: ${arrowSize * 2}px solid black;
    top: ${top}px;
    left: ${left}px;
    display: ${display};`;

  return `<div class='${arrowContainerClass}' style='${arrowContainerStyles}'>
        <div class='${arrowClass}' style='${arrowStyles}'></div>
      </div>`;
};
